module.exports = __webpack_public_path__ + "static/media/ed-nicol-r.8694c5ee.jpg";